import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editProjectName: {
		id: 'horizontal.nav.header.editable.title.edit.project.name',
		defaultMessage: 'Project name',
		description: 'Label for the button that allows editing the project name',
	},
	editProjectNameGalaxia: {
		id: 'horizontal.nav.header.editable.title.edit.project.name-galaxia',
		defaultMessage: 'Space name',
		description: 'Label for the button that allows editing the project name',
	},
});
